import data from "../data"

// 班级出勤率
// import classAttendanceRate from "../items/class_attendance_rate"

export default {
	path:'data',
	name:'data',
	component:data,
	children:[
		// {
		// 	path:'class/attendance/rate',
		// 	name:'class_attendance_rate',
		// 	component:classAttendanceRate
		// },
	]
}